export { default } from '@shikijs/langs/stylus'
